import React from 'react';
import classes from './index.module.scss';
import styled from "styled-components"

interface Props {
}

export const Footer = styled.div`
    height: 60px;
`;